import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/boolean-list';
import ListGroupHeaderComponent from './components/boolean-group-list-header';
import ViewComponent from './components/boolean-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/boolean-form-new';
import AggregateBoolean from "core/fields/aggregate/aggregate-boolean";
import AggregateBooleanComponent from "core/fields/custom/boolean/components/aggregate-boolean";
import normalizeBoolean from "../../import/normalize/normalize-boolean";
import FieldBooleanViewInImport from "../../import/view-in-preview/boolean-view-in-preview";

export default class BooleanCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);

        // mi nikogda ne ichem po checkbox :)
        this.isSearchable = false;
    }

    /*listItemGroupFunction() {
        return i=>!!i.item.customFieldsData[this.customField.id]
    }*/

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? customFieldsData[this.customField.id] : '';
    }

    getValue(item, params = {}) {
        const availableCustomFieldsIds = _.get(params, 'availableCustomFieldsIds', [this.customField.id]);
        return availableCustomFieldsIds.includes(this.customField.id) ? !!item.customFieldsData[this.customField.id] : null;
    }

    getAggregateClass() {return AggregateBoolean}

    getAggregateOptions() {return [
        gd.const.aggregate.type.CHECKED_TOTAL,
        /*gd.const.aggregate.type.CHECKED_NOT_CHECKED,*/
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.CHECKED_TOTAL}

    listItemSortFunctions(sort) {
        return {
            functions: [i => !!i.item.customFieldsData[this.customField.id]],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    get AggregateComponent() {return AggregateBooleanComponent.bind(null, this.getAggregateOptions())}

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeBoolean(value);
    }

    getComponentViewInImport() {
        return FieldBooleanViewInImport;
    }
}
